// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import LoadingCircle from '@its-svp/svp-common-ui';
import ImportSourcesModalUploaderItem from './ImportSourcesModalUploaderItem';
// css
import '../../styles/components/sources/ImportSourcesModalUploaderDropzone.scss';


class ImportSourcesModalUploaderDropzone extends Component {
  constructor(props) {
    super(props);
  }

  isImporting() {
    return this.props.importing;
  }

  renderFiles() {
    const { files, makeOnRemoveFile, importResults } = this.props;

    return files.toSeq().map((file, uuid) => (
      <ImportSourcesModalUploaderItem
        key={uuid}
        onRemove={makeOnRemoveFile(uuid)}
        file={file}
        uuid={uuid}
        result={importResults[uuid]}
      />
    ));
  }

  renderImportErrors() {
    const { importErrors } = this.props;

    return importErrors.map((error, index) => (
      <div key={index} className='import-sources-modal-uploader-dropzone__import-error'>
        <span>Import failed:</span> {error}
      </div>
    ));
  }

  renderFileList(openFileDialog) {
    const { allowUpload, importErrors } = this.props;

    return (
      <div>
        {!!importErrors.length &&
          <div className='import-sources-modal-uploader-dropzone__import-errors'>
            {this.renderImportErrors()}
          </div>
        }
        {!importErrors.length &&
          <div className='import-sources-modal-uploader-dropzone__file-list'>
            {this.renderFiles()}
          </div>
        }
        {allowUpload &&
          <div className='import-sources-modal-uploader-dropzone__file-list-notice'>
            <p>Drag and drop or <a href='#' onClick={openFileDialog}>select additional files</a> to upload</p>
          </div>
        }
      </div>
    );
  }

  renderEmpty(openFileDialog) {
    return (
      <div className='import-sources-modal-uploader-dropzone__empty-notice'>
        <p>Drag and drop files or <a href='#' onClick={openFileDialog}>select files</a> to upload</p>
      </div>
    );
  }

  renderLoading() {
    return (
      <div className='import-sources-modal-uploader-dropzone__loading'>
        Importing...
        <LoadingCircle />
      </div>
    );
  }

  renderContent(openFileDialog) {
    if (this.isImporting()) {
      return this.renderLoading();
    }

    if (this.props.files.size) {
      return this.renderFileList(openFileDialog);
    }

    return this.renderEmpty(openFileDialog);
  }

  render() {
    const { onDropFile, allowUpload } = this.props;

    return (
      <Dropzone
        disabled={!allowUpload}
        disableClick
        onDrop={onDropFile}
      >
        {({ getRootProps, getInputProps, open }) => (
          <div
            className='import-sources-modal-uploader-dropzone'
            {...getRootProps()}
          >
            <input {...getInputProps()} />
            {this.renderContent(() => open())}
          </div>
        )}
      </Dropzone>
    );
  }
}

ImportSourcesModalUploaderDropzone.defaultProps = {
  allowUpload: true
};

ImportSourcesModalUploaderDropzone.propTypes = {
  onDropFile: PropTypes.func.isRequired,
  makeOnRemoveFile: PropTypes.func.isRequired,
  files: PropTypes.object.isRequired,
  allowUpload: PropTypes.bool,
  importResults: PropTypes.object.isRequired,
  importErrors: PropTypes.array.isRequired,
  importing: PropTypes.bool.isRequired
};

export default ImportSourcesModalUploaderDropzone;



// WEBPACK FOOTER //
// ./src/components/sources/ImportSourcesModalUploaderDropzone.js